import { useCallback } from 'react';

export function useMergedRefs<T>(...refs: React.Ref<T>[]): React.RefCallback<T> {
	const mergedRef = useCallback((inst: T | null) => {
		for (const ref of refs.filter(Boolean)) {
			if (typeof ref === 'function') {
				ref(inst);
			} else if (ref) {
				(ref as React.MutableRefObject<T | null>).current = inst;
			}
		}
		(mergedRef as unknown as React.MutableRefObject<T | null>).current = inst;
	}, [refs]);
	return mergedRef;
}
